var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WujieVue',{attrs:{"width":"100%","height":"100%","name":"react16","url":_vm.react16Url}})
}
var staticRenderFns = []

export { render, staticRenderFns }